import React, {useState} from "react";
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";
import Intro from "../components/Intro";
import { makeStyles } from '@material-ui/core/styles';
import {currentFields, upcomingFields} from '../content/Fields';
import backgroundImage from '../resources/images/background.jpg';
import { Grid, Typography, useMediaQuery, Link} from "@material-ui/core";
import lodash from "lodash";

const useStyles = makeStyles((theme) => ({
    backgroundDiv: {
        height: "350px",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "100%",
        backgroundColor: '#141415',
		backgroundPosition: 'center',
        marginBottom: '20px',
        position: "relative"
    },
    attributeText: {
        fontSize: '8px',
        position: "absolute",
        bottom: "10px",
        right: '0'
    },
    contentDiv: {
        position: "relative",
        width: '100%',
        margin: 'auto',
        paddingTop: '100px',
        textAlign: 'center'
    },
    primaryText: {
        color: 'white',
        marginTop: '15px',
        marginBottom: '15px',
    },
    container: {
        marginTop: '50px',
        paddingLeft: '20px',
        paddingRight: '20px',
        width: '80%',
        [theme.breakpoints.down('xs')]: {
			width: '100%'
		},
    },
    line: {
        border: 'none',
        borderTop:'5px solid  #2962ff',
        height:'5px',
        width:'10%',
    },
    upcoming: {
        paddingTop: '30px',
        paddingBottom: '30px',
    },
    dottedLine: {
        marginTop: '40px',
        marginBottom: '40px',
        border: 'none',
        borderTop:'5px dotted #bbbfca',
        height:'5px',
        width:'10%',
    }
}));


function FieldsPage() {
    const classes=useStyles();
    const lowerWidth = useMediaQuery('(max-width:500px)');
    let [readMore, setReadMore] = useState([true, true, true, true, true, true, true]);

    function truncate(str, no_words) {
        return str.split(" ").splice(0, no_words).join(" ");
    }

    function toggle(index) {
        let readMoreUpdated = lodash.cloneDeep(readMore);
        readMoreUpdated[index] = !readMore[index];
        setReadMore(readMoreUpdated);
    }

    return (
        <div>
            <AppHeader appBarTitle="ELECTRONICS CLUB IIT GUWAHATI"/>
            <Intro primaryText="Domains We Work On" secondaryText="Explore and Grow" pagename="About" classes={classes}/>    
            {(currentFields)? currentFields.map((field, index) => {
                return (
                    <center>
                        <Grid container className = {classes.container}>
                            <Grid item xs={12}>
                                <Typography variant='h4'>{field.name}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <hr className={classes.line}></hr>
                            </Grid>          
                            <Grid item xs={12}>
                                {
                                    (lowerWidth)? (
                                        <Typography variant='body1'>                                     
                                            {
                                                (readMore[index])? (
                                                    truncate(field.desc, 70) + ' ...  '
                                                )
                                                :
                                                field.desc
                                            }
                                            {
                                                (readMore[index])? (
                                                    <Link onClick={() => toggle(index)} color="secondary" variant="body1">
                                                        Read More
                                                    </Link>
                                                )
                                                :
                                                    <Link onClick={() => toggle(index)} color="secondary" variant="body1">
                                                        Read Less 
                                                    </Link>
                                            }
                                        </Typography> 
                                    )
                                    : 
                                    <Typography variant='body1' className={classes.upcoming}>{field.desc}</Typography>
                                }
                            </Grid>
                        </Grid>
                    </center>
                )
            }): null}
            <hr className={classes.dottedLine}></hr>
            <center><Typography variant = 'h3'>Upcoming Domains</Typography></center>
            {(upcomingFields)? upcomingFields.map((field, index) => {
                return (
                    <center>
                        <Grid container className = {classes.container}>
                            <Grid item xs={12}>
                                <Typography variant='h4'>{field.name}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <hr className={classes.line}></hr>
                            </Grid>          
                            <Grid item xs={12}>
                                {
                                    (lowerWidth)? (
                                        <Typography variant='body1'>                                     
                                            {
                                                (readMore[index+5])? (
                                                    truncate(field.desc, 70) + ' ...  '
                                                )
                                                :
                                                field.desc
                                            }
                                            {
                                                (readMore[index+5])? (
                                                    <Link onClick={() => toggle(index+5)} color="secondary" variant="body1">
                                                        Read More
                                                    </Link>
                                                )
                                                :
                                                    <Link onClick={() => toggle(index+5)} color="secondary" variant="body1">
                                                        Read Less 
                                                    </Link>
                                            }
                                        </Typography> 
                                    )
                                    : 
                                    <Typography variant='body1'>{field.desc}</Typography>
                                }
                            </Grid>
                        </Grid>
                    </center>
                )
            }): null}           
            <AppFooter />
        </div>
    )
}

export default FieldsPage;